var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.00006C7.58172 4.00006 4 7.58178 4 12.0001C4 16.4183 7.58172 20.0001 12 20.0001C16.4183 20.0001 20 16.4183 20 12.0001C20 7.58178 16.4183 4.00006 12 4.00006ZM2 12.0001C2 6.47721 6.47715 2.00006 12 2.00006C17.5228 2.00006 22 6.47721 22 12.0001C22 17.5229 17.5228 22.0001 12 22.0001C6.47715 22.0001 2 17.5229 2 12.0001ZM16.6644 8.75265C17.0771 9.11957 17.1143 9.75164 16.7474 10.1644L11.4141 16.1644C11.2243 16.3779 10.9523 16.5001 10.6667 16.5001C10.381 16.5001 10.109 16.3779 9.91926 16.1644L7.25259 13.1644C6.88567 12.7516 6.92285 12.1196 7.33564 11.7527C7.74842 11.3857 8.38049 11.4229 8.74741 11.8357L10.6667 13.9949L15.2526 8.8357C15.6195 8.42291 16.2516 8.38573 16.6644 8.75265Z",
    fill: "#228B22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.74dbee8b0544680ed420b9ffe0c21a93.svg";
export { ForwardRef as ReactComponent };